<template>
  <a-icon :component="component"></a-icon>
</template>

<script>
export default {
  name: 'CloudServerIcon',
  data () {
    return {
      component: {
        template: `
          <svg viewBox="0 0 1028 1024" width="1em" height="1em">
            <path d="M85.461269 0h853.077462c47.08046 0 85.461269 38.38081 85.461269 85.461269v853.077462c0 47.08046-38.38081 85.461269-85.461269 85.461269H85.461269C38.38081 1023.488256 0 985.107446 0 938.026987V85.461269C0 38.38081 38.38081 0 85.461269 0z" fill="currentColor" p-id="24259" cursorshover="true"></path>
            <path d="M709.277361 344.915542c0 5.629185 4.093953 10.234883 9.723139 11.258371 75.738131 10.746627 134.076962 75.738131 134.076961 154.546727 0 83.414293-66.014993 151.988006-148.405797 155.570215h-22.004997v-127.936032c0-23.54023-18.934533-42.474763-42.474763-42.474763H383.808096c-23.54023 0-42.474763 18.934533-42.474763 42.474763v127.936032h-9.723138c-89.043478 0-160.687656-72.155922-160.687656-161.199401s72.155922-161.1994 160.687656-161.1994c9.211394 0 18.934533 1.023488 28.145927 2.558721 1.023488 0 1.535232-0.511744 1.535232-1.023489 0-96.207896 77.785107-174.504748 173.993004-174.504747s173.993003 77.785107 173.993003 173.993003z m-56.803598 185.251375h-281.45927v136.635682h281.45927v-136.635682z m-182.180909 54.756621H402.230885v26.098951h67.550224v-26.098951z m-99.278361 110.024988h281.45927v136.635682h-281.45927v-136.635682z m31.216392 54.756621h67.550224v26.098951H402.230885v-26.098951z" fill="#FFFFFF" p-id="24260"></path>
          </svg>
        `
      }
    }
  }
}
</script>
